import React, { useEffect, useRef, useState } from 'react'
import { FiChevronRight } from 'react-icons/fi'

const ACTIVATION_DURATION = 720

const isModifiedClick = (event) => (
  event.button !== 0
  || event.metaKey
  || event.ctrlKey
  || event.shiftKey
  || event.altKey
)

const prefersReducedMotion = () => (
  typeof window !== 'undefined'
  && typeof window.matchMedia === 'function'
  && window.matchMedia('(prefers-reduced-motion: reduce)').matches
)

const followLink = (href) => {
  if (href.startsWith('#')) {
    if (window.location.hash === href) {
      document.querySelector(href)?.scrollIntoView()
      return
    }

    window.location.hash = href.slice(1)
    return
  }

  window.location.assign(href)
}

const AnimatedCtaLink = ({
  href,
  label,
  labelEn,
  activatingLabel = 'Ouverture…',
  activatingLabelEn = 'Opening…',
  className = '',
  variant = 'panel',
  icon: Icon = FiChevronRight,
  onActivate,
  onActivationChange,
  onClick,
  onNavigate,
  ...linkProps
}) => {
  const [isActivating, setIsActivating] = useState(false)
  const activationTimerRef = useRef(null)

  useEffect(() => () => window.clearTimeout(activationTimerRef.current), [])

  const handleClick = (event) => {
    onClick?.(event)

    if (event.defaultPrevented) return

    // Modified clicks must remain native so opening the destination in a new
    // tab never changes the current SPA route.
    if (isModifiedClick(event)) {
      return
    }

    if (prefersReducedMotion()) {
      onNavigate?.()
      return
    }

    event.preventDefault()
    if (isActivating) return

    setIsActivating(true)
    onActivationChange?.(true)
    onActivate?.()

    activationTimerRef.current = window.setTimeout(() => {
      setIsActivating(false)
      onActivationChange?.(false)
      onNavigate?.()
      followLink(href)
    }, ACTIVATION_DURATION)
  }

  const classes = [
    'octo-cta',
    variant && `octo-cta--${variant}`,
    isActivating && 'octo-cta--activating',
    className,
  ].filter(Boolean).join(' ')

  return (
    <a
      {...linkProps}
      className={classes}
      data-animated-cta=""
      href={href}
      aria-busy={isActivating || undefined}
      onClick={handleClick}
    >
      <span className="octo-cta__copy">
        <span lang="fr">{isActivating ? activatingLabel : label}</span>
        <small lang="en">{isActivating ? activatingLabelEn : labelEn}</small>
      </span>
      <Icon aria-hidden="true" />
    </a>
  )
}

export { ACTIVATION_DURATION }
export default AnimatedCtaLink
